import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/social-x.svg';
import { Icon } from '../Icon/Icon';
export const SocialXIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
